<template>
    <div>
        <b v-if="conditionToShow('request')" class="showMoreData" style="color: red" @click="handleAction('1')">
            Request To Delete Assignment
        </b>
        <b v-if="conditionToShow('sentApproval')" style="color: red">
            Sent For Delete Approval
        </b>
        <b v-if="conditionToShow('approve') &&
            $sessionsStorage.get('designation') == 'Admin' &&
            $sessionsStorage.get('nameUser') == 'Bhavneesh'" class="showMoreData" style="color: red" @click="handleAction('2')">
            Approve Delete Request /
        </b>
        <b v-if="conditionToShow('reject') &&
            $sessionsStorage.get('designation') == 'Admin' &&
            $sessionsStorage.get('nameUser') == 'Bhavneesh'" class="showMoreData" style="color: red"
            @click="handleAction('3')">
            Reject Delete Request
        </b>
        <b v-if="conditionToShow('delete') &&
            $sessionsStorage.get('designation') == 'Admin' &&
            $sessionsStorage.get('nameUser') == 'Bhavneesh'" class="showMoreData" style="color: red" @click="handleAction('4')">
            Delete Assignment
        </b>

        <b-modal id="modal-AssRemove-conf" ref="modal-AssRemove-conf" title="Confirmation Remove Assignment" centered
            no-close-on-esc no-close-on-backdrop hide-footer>
            <b-row>
                <b-col md="12" align="center" class="error">
                    <h5>{{ PaymentType }}</h5>
                </b-col>
            </b-row>

            <b-button style="font-size: 0.675rem" @click="closeModalRemoveAss" variant="danger"
                class="pull-left">No</b-button>
            <b-button style="font-size: 0.675rem" variant="success" class="pull-right"
                @click="execActions(PaymentTypeModuleId, PaymentTypeID, PaymentTypeJOBNo)">
                Yes</b-button>
        </b-modal>
        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
            ref="addPopMail"></md-dialog-confirm>
        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
            ref="addPopApprove"></md-dialog-confirm>
        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
            ref="addPopReject"></md-dialog-confirm>
        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseAction"
            ref="addPopDelete"></md-dialog-confirm>
    </div>
</template>

<script>
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
export default {
    props: {
        item: { type: Object, required: true }, // Represents `row10.item`
        JobNo: { type: String, required: true },
        JobID: { type: String, required: true },
        sessionsStorage: { type: Object, required: true } // Pass `$sessionsStorage`
    },
    data() {
        return {
            alert: {
                content: "Are you sure you want to delete ..!",
                ok: "ok",
            },
            eventId: '',
            invnoErrFlag: false,
            PaymentType: "",
            PaymentTypeModuleId: "",
            PaymentTypeID: "",
            PaymentTypeJOBNo: "",
        }
    },
    methods: {
        onCloseAction(type) {
            if (type != "cancel") {
                let payload = {
                    allModuleId: this.JobID,
                    salesExecutionNo: this.JobNo,
                    eventId: this.eventId,
                };
                console.log(payload);

                let options = {
                    method: "POST",
                    url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
                    data: JSON.stringify(payload),
                    crossDomain: true,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: this.$sessionsStorage.get("loginId"),
                    },
                };
                axios(options)
                    .then((result) => {
                        const { statusText, status, data } = result;
                        if (status == 200 && data) {
                            this.$emit("refreshData");
                        }
                    })
                    .catch((error) => { });
            }
        },
        conditionToShow(type) {
            const { deleteRequest, ApproveRejectDelReq, asignDeleted } = this.item;
            const isMobilePort = this.sessionsStorage.get("is_Mobile") === "port";

            switch (type) {
                case "request":
                    return deleteRequest === "0" && !isMobilePort;
                case "sentApproval":
                    return (
                        deleteRequest === "1" &&
                        ApproveRejectDelReq === "0" &&
                        ["manager", "employee"].includes(
                            this.sessionsStorage.get("designation")
                        )
                    );
                case "approve":
                    return (
                        deleteRequest === "1" &&
                        ApproveRejectDelReq !== "2" &&
                        ["Admin", "HOD"].includes(
                            this.sessionsStorage.get("designation")
                        ) &&
                        !isMobilePort
                    );
                case "reject":
                    return deleteRequest === "1" && ApproveRejectDelReq !== "2" && !isMobilePort;
                case "delete":
                    return (
                        ApproveRejectDelReq === "2" &&
                        asignDeleted !== "1" &&
                        !isMobilePort
                    );
                default:
                    return false;
            }
        },
        async handleAction(actionId) {
            // this.$emit("refreshData"); // Emit event to refresh parent data
            this.PaymentType = "";
            this.PaymentTypeModuleId = this.JobID;
            this.PaymentTypeID = actionId;
            this.PaymentTypeJOBNo = this.JobNo;

            const checkValueExit = await this.getPaymentExist(this.JobID);
            console.log("checkValueExit=>", checkValueExit)
            if (checkValueExit.Payment_Status == "Yes") {
                this.PaymentType =
                    "Expenses have been Raised in this assignment. Are you sure you want to raise delete Request? Payment Type-" + checkValueExit.PaymentType;
                this.$refs["modal-AssRemove-conf"].show();
            } else {
                this.execActions(this.JobID, actionId, this.JobNo);
            }
        },

        async getPaymentExist(allModuleId) {
            this.PaymentType = "";
            return new Promise((resolve) => {
                let payload = {
                    allModuleId: allModuleId,
                    itemCode: "checkPaymentExist",
                };
                let options = {
                    method: "POST",
                    url: `${URL_BASE}/Api_Dashboard/getAllCSODash.php`,
                    data: JSON.stringify(payload),
                    crossDomain: true,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: this.sessionsStorage.get("loginId"),
                    },
                };
                axios(options)
                    .then((result) => {
                        const { statusText, status, data } = result;
                        this.PaymentType = "";
                        if (status == 200 && data) {
                            if (data.Payment_Status === "Yes") {
                                this.invnoErrFlag = true;
                                this.PaymentType = data.PaymentType;
                            } else {
                                this.invnoErrFlag = false;
                            }
                            resolve(data);
                        }
                    })
                    .catch((error) => {
                        resolve(false);
                    });
            });
        },

        execActions(allModuleId, actionId, series) {

            this.eventId = actionId;
            this.closeModalRemoveAss();
            if (actionId === "1") {
                this.alert.content = "Send Mail For Approval?";
                this.$refs["addPopMail"].open();
            }
            if (actionId === "2") {
                this.alert.content = "Are you sure you want to Approve?";
                this.$refs["addPopApprove"].open();
            }
            if (actionId === "3") {
                this.alert.content = "Are you sure you want to Reject?";
                this.$refs["addPopReject"].open();
            }
            if (actionId === "4") {
                this.alert.content = "Are you sure you want to delete this Execution?";
                this.$refs["addPopDelete"].open();
            }
        },

        closeModalRemoveAss() {
            this.PaymentType = "";
            this.PaymentTypeModuleId = "";
            this.PaymentTypeID = "";
            this.PaymentTypeJOBNo = "";
            this.$refs["modal-AssRemove-conf"].hide();
        }
    }
};
</script>

<style scoped>
.showMoreData {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// MSDeleteRequest.vue?160c3953